module.exports = __webpack_public_path__ + "img/img_aboutcoin.0cf8dbf8.png";